module.exports = "/_next/static/resources/array-07dabfa59671b30473150703c65ac88b.webp";